export interface IApprover {
    name: string;
    maxApprovalDays: number;
}

export interface IApprovalSetting {
    id?: number;
    company_Name?: string;
    branch_Name?: string;
    department_Name?: string;
    company_Id: number;
    branch_Id: number;
    department_Id: number;
    approval_Type:number,
    approvers: IApprover[];
}

export const head = [
    { id: 1, header: 'S. No' },
    { id: 2, header: 'Approval Type' },
    { id: 3, header: 'Company Name' },
    { id: 4, header: 'Branch Name' },
    { id: 5, header: 'Department Name' },
    { id: 6, header: 'Approvers' },
    { id: 7, header: 'Action' },
];


export const approvalType = [
    { value: 1, label: "Leave Approval" },
    { value: 2, label: "Remote Approval" }
]